import "./services-tech-stack.css";
import techStackData from "./techStackData";



const ServicesTechStack = () => {
  return (
    <section className="services-tech">
      <div className="services-tech__container">
        {/* HEADER */}
        <div className="services-tech__header section-header">
          <span className="services-tech__badge">Technology Stack</span>

          <h2 className="services-tech__title">
            Modern Technologies We <span>Build With</span>
          </h2>

          <p className="services-tech__subtitle">
            We use battle-tested, modern technologies to build secure, scalable,
            and high-performance digital products.
          </p>
        </div>

        {/* STACK */}
        <div className="services-tech__groups">
          {techStackData.map((group, index) => (
            <div className="services-tech__group" key={index}>
              <h3 className="services-tech__group-title">{group.category}</h3>

              <div className="services-tech__grid">
                {group.techs.map((tech, i) => (
                  <div className="services-tech__card" key={i}>
                    <div className="services-tech__icon">{tech.icon}</div>
                    <span>{tech.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesTechStack;
